module.exports = __webpack_public_path__ + "static/media/newsletter.3cb646cc.svg";